module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_19_C_1.3e14c8b7.mp3";